import React from "react";

const About = () => {
  return <div>
   <div className="bg-gray-100 min-h-screen py-12 px-4 sm:px-8">
      <div className="max-w-6xl mx-auto bg-white shadow-2xl rounded-2xl p-10">
        <h1 className="text-4xl font-bold text-blue-600 mb-6 text-center">About Us</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div>
            <img
              src="https://images.unsplash.com/photo-1441986300917-64674bd600d8"
              alt="Fashion and Beauty Products"
              className="w-full rounded-xl shadow-lg"
            />
          </div>
          <div>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Your Ultimate Destination for Fashion & Beauty</h2>
            <p className="text-gray-600 leading-relaxed">
              Welcome to <span className="font-semibold text-blue-600">Shoplintic</span>, your premier online destination for fashion and beauty products! From trendy clothing and accessories to premium cosmetics and skincare, we curate the finest collection to enhance your personal style and beauty routine.
            </p>
            <p className="text-gray-600 mt-4">
              We're passionate about fashion and beauty, committed to providing exceptional quality products with outstanding customer service—from secure shopping to fast delivery and personalized beauty advice.
            </p>
            <ul className="mt-6 space-y-2">
              <li className="flex items-center text-gray-700">
                👗 &nbsp; Premium Clothing & Accessories
              </li>
              <li className="flex items-center text-gray-700">
                💄 &nbsp; High-Quality Cosmetics & Skincare
              </li>
              <li className="flex items-center text-gray-700">
                🚚 &nbsp; Fast & Reliable Shipping
              </li>
              <li className="flex items-center text-gray-700">
                🔄 &nbsp; Flexible Returns & Exchanges
              </li>
              <li className="flex items-center text-gray-700">
                💬 &nbsp; Beauty & Style Consultation Support
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 text-center">
          <h3 className="text-xl font-semibold text-gray-800">Why Choose Us?</h3>
          <p className="text-gray-600 mt-3 max-w-3xl mx-auto">
            We don't just sell fashion and beauty products—we deliver style, confidence, and quality. Whether you're updating your wardrobe or enhancing your beauty routine, Shoplintic is here to make your shopping experience elegant, personalized, and enjoyable. Discover your perfect look with our carefully selected collection of clothing and cosmetics.
          </p>
        </div>
      </div>
    </div>

  </div>;
};

export default About;
